import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { Button } from '../ui/button';
import { Moon, Sun } from 'lucide-react';
import { cn } from '../../lib/utils';

export function ThemeToggle({ className }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className={cn("relative overflow-hidden", className)}
      data-testid="theme-toggle"
      type="button"
    >
      <Sun className={cn(
        "h-5 w-5 transition-all duration-300",
        theme === 'dark' ? 'rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100'
      )} />
      <Moon className={cn(
        "absolute h-5 w-5 transition-all duration-300",
        theme === 'dark' ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0'
      )} />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
